/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RatingDtoModel, RatingDtoModelType } from "./RatingDtoModel"
import { RatingDtoModelSelector } from "./RatingDtoModel.base"
import { RootStoreType } from "./index"


/**
 * CustomerSatisfactionDtoBase
 * auto generated base class for the model CustomerSatisfactionDtoModel.
 */
export const CustomerSatisfactionDtoModelBase = ModelBase
  .named('CustomerSatisfactionDto')
  .props({
    __typename: types.optional(types.literal("CustomerSatisfactionDto"), "CustomerSatisfactionDto"),
    isEnabled: types.union(types.undefined, types.null, types.boolean),
    rating: types.union(types.undefined, types.null, types.late((): any => RatingDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerSatisfactionDtoModelSelector extends QueryBuilder {
  get isEnabled() { return this.__attr(`isEnabled`) }
  rating(builder: string | RatingDtoModelSelector | ((selector: RatingDtoModelSelector) => RatingDtoModelSelector) | undefined) { return this.__child(`rating`, RatingDtoModelSelector, builder) }
}
export function selectFromCustomerSatisfactionDto() {
  return new CustomerSatisfactionDtoModelSelector()
}

export const customerSatisfactionDtoModelPrimitives = selectFromCustomerSatisfactionDto().isEnabled
